import React from "react";

const BestBadge: React.FC<{ best: string }> = ({ best }) => (
  <span
    className={`px-3 py-1 rounded-full text-white text-xs font-medium inline-block ${
      best === "AWS" ? "bg-orange-500" : best === "Azure" ? "bg-blue-600" : "bg-cyan-500"
    }`}
  >
    {best}
  </span>
);

export default BestBadge;
